/**
 * Settings API Service
 *
 * Domain-specific API operations for API Key management
 * Uses httpClient for infrastructure concerns (token rotation, error handling)
 */

import { httpClient } from './http-client.service';
import type {
  GetApiKeyResponse,
  GenerateKeyResponse,
  GetApiKeyRequest,
  RegenerateKeyRequest,
} from '../types/settings';

class SettingsApiService {
  /**
   * Get API key details
   * @param params - Request parameters (all: 'true' for all keys)
   * @returns API key data
   */
  async getKeyDetails(params: GetApiKeyRequest): Promise<GetApiKeyResponse> {
    const response = await httpClient.post<GetApiKeyResponse>('apiKey', params);
    return response.data;
  }

  /**
   * Generate new API key
   * @returns Generated API key data
   */
  async generateKey(): Promise<GenerateKeyResponse> {
    const response = await httpClient.post<GenerateKeyResponse>('AAapikey/generate', {});
    return response.data;
  }

  /**
   * Regenerate existing API key
   * @param params - Request parameters with key ID
   * @returns Regenerated API key data
   */
  async regenerateKey(params: RegenerateKeyRequest): Promise<GenerateKeyResponse> {
    const response = await httpClient.post<GenerateKeyResponse>(
      'update/AAapikey/regenerate',
      params
    );
    return response.data;
  }
}

// Export singleton instance
export const settingsAPI = new SettingsApiService();

// Export class for testing
export { SettingsApiService };
